import React, { useState, useEffect } from "react";
import {
  Space,
  Table,
  Form,
  theme,
  Row,
  Col,
  Input,
  DatePicker,
  Button,
  message,
  Select,
} from "antd";
import axios from "axios";
import moment from "moment/moment";
import localhost from "../../constants/localhost";
import Detail from "./detail";

const mockData = Array(10)
  .fill(null)
  .map((_, index) => {
    return {
      id: index,
      sensitiveWord: "政府",
      level: "图文混排",
      reporter: "一只胖团团",
      reporterPhone: "13216186259",
      createDate: "2025-04-20 19:15:11",
      status: 1,
    };
  });

const SensitiveWords = () => {
  const { token } = theme.useToken();
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10 });
  const [dataInfo, setDataInfo] = useState({
    total: 20,
    dataSource: mockData,
  });
  const [loading, setLoading] = useState(false);

  const getData = () => {
    setLoading(true);
    const formData = form.getFieldsValue();
    if (formData.createDate) {
      formData.createDateStart = moment(formData.createDate[0]).format(
        "YYYY-MM-DD"
      );
      formData.createDateEnd = moment(formData.createDate[1]).format(
        "YYYY-MM-DD"
      );
      formData.createDate = undefined;
    }
    axios
      .post(`${localhost}/manage/sensitiveWordManage/queryList`, {
        pageNo: 1,
        pageSize: 20,
        ...formData,
      })
      .then((res) => {
        setDataInfo({
          total: res?.data?.total || 0,
          dataSource: res?.data?.list || [],
        });
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const pagination = {
    showTotal: (total, range) => {
      return `当前第 ${range[0]} 到 ${range[1]} 条，总共${total}条数据`;
    },
    total: dataInfo.total,
    current: pageInfo.pageNo,
    pageSize: pageInfo.pageSize,
    onChange: (page, pageSize) => {
      setPageInfo({ pageNo: page, pageSize: pageSize }, () => {
        getData();
      });
    },
    onShowSizeChange: (current, size) => {
      setPageInfo({ pageNo: current, pageSize: size }, () => {
        getData();
      });
    },
  };

  useEffect(() => {
    getData();
  }, []);

  const onSearch = () => {
    setPageInfo({ pageNo: 1, pageSize: 10 });
  };

  const onReset = () => {
    form.resetFields();
    setPageInfo({ pageNo: 1, pageSize: 10 });
  };

  const formStyle = {
    maxWidth: "none",
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const setDisplay = ({ id, status }) => {
    axios
      .get(
        `${localhost}/manage/sensitiveWordManage/updateStatus?id=${id}&status=${status}`
      )
      .then((res) => {
        message.success(`${status === 1 ? "启用" : "禁用"}成功！`);
        getData();
      });
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: "敏感词",
      dataIndex: "sensitiveWord",
    },
    {
      title: "等级",
      dataIndex: "level",
    },
    {
      title: "创建时间",
      dataIndex: "createDate",
    },
    {
      title: "状态",
      dataIndex: "status",
      render: (val) => {
        return val === 1 ? "启用中" : "禁用中";
      },
    },
    {
      title: "操作",
      key: "action",
      dataIndex: "action",
      fixed: "right",
      render: (_, record) => (
        <Space size="middle">
          <Detail detail={record} />
          {record.status === 1 ? (
            <a
              onClick={() => {
                setDisplay({ id: record.id, status: 0 });
              }}
            >
              禁用
            </a>
          ) : (
            <a
              onClick={() => {
                setDisplay({ id: record.id, status: 1 });
              }}
            >
              启用
            </a>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div>
        <Form
          form={form}
          name="advanced_search"
          style={formStyle}
          onFinish={onFinish}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item name="sensitiveWord" label="敏感词">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="createDate" label="创建时间">
                <DatePicker.RangePicker />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="status" label="状态">
                <Select placeholder="请选择渠道" allowClear>
                  <Select.Option value={1}>启用</Select.Option>
                  <Select.Option value={0}>禁用</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="level" label="等级">
                <Input />
              </Form.Item>
            </Col>
            <Col span={16}>
              <div style={{ textAlign: "right" }}>
                <Space size="small">
                  <Button type="primary" onClick={onSearch}>
                    搜索
                  </Button>
                  <Button onClick={onReset}>重置</Button>
                </Space>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
      <div style={{ marginTop: 16 }}>
        <Space size={16}>
          <Button type="primary">新建</Button>
          <Button type="primary">下载模板</Button>
          <Button>批量导入</Button>
        </Space>
      </div>
      <div style={{ marginTop: 16 }}>
        <Table
          rowKey="id"
          columns={columns}
          scroll={{ x: "max-content", y: "calc(100vh - 240px - 55px - 64px)" }}
          style={{
            height: "calc(100vh - 240px)",
            overflowY: "scroll",
          }}
          rowSelection={{
            selectedRowKeys,
            onChange: (keys, selectedRows) => {
              console.log("selectedRowKeys changed: ", keys);
              setSelectedRowKeys(keys);
            },
          }}
          // loading={loading}
          dataSource={dataInfo.dataSource}
          pagination={pagination}
        />
      </div>
    </div>
  );
};

export default SensitiveWords;
